import { render } from "./index.vue?vue&type=template&id=3141d3fc&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=3141d3fc&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-3141d3fc"

export default script